import axiosInstance from '../../../helpers/backend_helper';

const updateStory = async ({id, name, excerpt, type, image}) => {
  try {
    const formData = new FormData();
    name && formData.append('name', name);
    excerpt && formData.append('excerpt', excerpt);
    type && formData.append('type', type);
    image && formData.append('image', image);

    const response = await axiosInstance.post(`stories/update/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error updating book:', error);
    throw error;
  }
};

export default updateStory;
